import { Result } from '../util/result';
import { API } from './API';

/**
 * creates an `API` backed by the product's API
 * @param options
 * @deprecated for this project, we're not using this, please see APIConfigs.ts instead
 */
export const risenHopeAPIClient = (options: {
  /** The API's base URL. */
  baseURL: string;
}): API => {
  return {
    getUser: () => Promise.resolve(Result.success({ roles: [] })),
  };
};
